// extracted by mini-css-extract-plugin
export default {"title":"a_-z","warning":"b_-z","sizeOptionsLegendText":"c_-z"};